<template>
  <div style="height: 100%;">
    <el-row style="margin-bottom:10px;height: 30px;" class="flex">
      <el-col :span="4" v-if="theProjectId == 0">
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" >
       
      </el-col>
      <el-col :span="4">
        <el-select v-model="form.userId" @change="theDtChange" size="small" filterable clearable placeholder="请选择学员">
          <el-option v-for="item in getProjectUserAll_data.data || []" :key="item.userId" :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="form.getType" @change="thetimechange" size="small" clearable placeholder="请选择时间段">
          <el-option v-for="item in timeType" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-date-picker size="small" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="selectTime" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
    </el-row>

    <div v-if="form.userId"
      style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-around;align-content:space-around;height: calc(100% - 60px);margin-bottom: 20px;">
      <div class="Divbox">
        <div ref="echart1" style="width: 100%;height: 100%;">

        </div>
      </div>
      <div class="Divbox" style="display: flex;flex-wrap: wrap;">
        <div style="display: flex;width: 50%;height: 49%;">
          <div style="width: 50%;height: 100%;padding: 15px;">
            <el-avatar :size="110" :src="getStatisticsUser_data.data.userHeader || userImg">
            </el-avatar>
          </div>
          <div style="width: 50%;display: flex;flex-direction: column;justify-content: space-around;font-size: 18px;">
            <p> 姓名:{{getStatisticsUser_data.data.userName || '暂无'}}</p>
            <p> 区县:{{getStatisticsUser_data.data.department.dtName || '暂无'}}</p>
          </div>
        </div>
        <div
          style="width: 50%;height: 49%;display: flex;flex-direction: column;justify-content: space-around;align-items: center;">
          <p style="font-size: 19px;">拜访排名</p>
          <p style="font-size: 17px;">{{getStatisticsUser_data.data.visitorRank || '暂无'}}</p>
        </div>
        <div
          style="width: 50%;height: 49%;display: flex;flex-direction: column;justify-content: space-around;align-items: center;">
          <p style="font-size: 19px;">业绩排名</p>
          <p style="font-size: 17px;">{{getStatisticsUser_data.data.kpiRank || '暂无'}}</p>
        </div>
        <div
          style="width: 50%;height: 49%;display: flex;flex-direction: column;justify-content: space-around;align-items: center;">
          <p style="font-size: 19px;">积分排名</p>
          <p style="font-size: 17px;">{{getStatisticsUser_data.data.pointsRank || '暂无'}}</p>
        </div>
      </div>
      <div class="Divbox">
        <div ref="echart2" style="width: 100%;height: 100%;">

        </div>
      </div>
      <div class="Divbox">
        <div style="font-size: 19px;margin: 15px 10px;font-weight: 600;height: 30px;">
          · 拜访明细
        </div>
        <div style="margin: 0 15px;height:calc(100% - 80px);overflow-y: scroll;" class="Divbox_box">
          <div v-for="item in getStatisticsUserVisitor_data.data || []">
            <el-card style="margin: 10px 0;font-size: 13px;">
              <p>客户单位:{{item.customName}}</p>
              <p>客户行业:{{item.btName}}</p>
              <p>归属网格:{{item.dtName}}</p>
              <p>拜访类型:{{item.uvcName}}</p>
              <p>走访时间:{{item.uvTime}}</p>
            </el-card>
          </div>
        </div>
      </div>
      <div class="Divbox">
        <div style="font-size: 19px;margin: 15px 10px;font-weight: 600;height: 30px;">
          · 签约明细
        </div>
        <div style="margin: 0 15px;height:calc(100% - 80px);overflow-y: scroll;" class="Divbox_box">
          <div v-for="item in getStatisticsUserOpportunity_data.data || []">
            <el-card style="margin: 10px 0;font-size: 13px;">
              <p>开单人员:{{item.userName}}</p>
              <p>订单金额:{{item.ouMoney}}</p>
              <p>业务名称:{{item.ouBusinessName}}</p>
              <p>客户单位:{{item.customName}}</p>
              <p>所属网格:{{item.dtName}}</p>
              <p>开单时间:{{item.createtime}}</p>
            </el-card>
          </div>
        </div>
      </div>
      <div class="Divbox">
        <div style="font-size: 19px;margin: 15px 10px;font-weight: 600;height: 30px;">
          · 互动明细
        </div>
        <div style="margin: 0 15px;height:calc(100% - 80px);overflow-y: scroll;" class="Divbox_box">
          <div v-for="item in getStatisticsUserInteract_data.data || []">
            <el-card style="margin: 10px 0;font-size: 13px;">
              <p>发布者:{{item.userName}}</p>
              <el-popover placement="top-start" title="互动内容" width="200" trigger="hover">
                <div v-html="item.clHtml"></div>
                <p slot="reference">标题: <span v-html="item.clTitle"></span> </p>
              </el-popover>
              <p>创建时间:{{item.createtime}}</p>
            </el-card>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data() {
      return {
        userImg: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        echartsStr1Value: [],
        echartsStr2Value: [],
        echartstr: '',
        echartstr2: '',
        theProjectId: '',
        form: {
          postId: 5,
          projectId: '',
          dtLevel: '',
          getType: '',
          startDate: '',
          endDate: '',
          userId: ''
        },
        timeType: [{
            label: "全部",
            value: 1
          },
          {
            label: "今日",
            value: 2
          },
          {
            label: "本周",
            value: 3
          },
          {
            label: "本月",
            value: 4
          },
        ],
        color: [
          ' #4992ff',
          ' #dd79ff',
          ' #fddd60',
          '  #ff6e76',
          ' #58d9f9',
          ' #05c091',
          '  #ff8a45',
          ' #8d48e3',

        ],
      }
    },
    mounted() {
      const _this = this
      window.addEventListener('resize', function() {
        _this.echartstr.resize()
        _this.echartstr2.resize()

      });
    },
    methods: {
      // 图标配置项
      DrawEcharts() {
        var _that = this
        this.echartstr = this.$echarts.init(this.$refs.echart1)
        this.echartstr.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 签约贡献',
            left: 'left',
            top: "20"
          }, //标题位置
          tooltip: {
            trigger: 'item',
            formatter: function(params) {
              let str = ''
              if (params.dataIndex == 0) {
                str = params.marker + params.name + ':' + '</br>' + (params.value + _that.echartsStr1Value[1]
                  .value)
              } else {
                str = params.marker + params.name + ':' + '</br>' + params.value
              }


              return str
            }
          }, //提示框组件 ---数据项图形触发
          legend: {
            orient: 'vertical', //图标列表的布局朝向
            left: 'right'
          },
          series: [{
            name: '拜访贡献',
            type: 'pie',
            radius: ['40%', '70%'],
            data: this.echartsStr1Value,
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
          }]
        })

        this.echartstr2 = this.$echarts.init(this.$refs.echart2)
        this.echartstr2.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 签约贡献',
            left: 'left',
            top: "20"
          }, //标题位置
          tooltip: {
            trigger: 'item',
            formatter: function(params) {
              let str = ''
              if (params.dataIndex == 0) {
                str = params.marker + params.name + ':' + '</br>' + (params.value + _that.echartsStr2Value[1]
                  .value)
              } else {
                str = params.marker + params.name + ':' + '</br>' + params.value
              }
              

              return str
            }
          }, //提示框组件 ---数据项图形触发
          legend: {
            orient: 'vertical', //图标列表的布局朝向
            left: 'right'
          },
          series: [{
            name: '签约贡献',
            type: 'pie',
            radius: '70%',
            data: this.echartsStr2Value,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        })


      },
      theProjectAllChange(e) {
       
        if(e == ''){
          this.form.projectId = e 
          
          return 
        }
        this.form.projectId = e;
        
      },
      theDtTChange(e) {
        this.form.dtLevel = e
        this.getProjectUserAll({
          postId: 5,
          projectId: this.form.projectId,
          dtLevel: this.form.dtLevel
        })

      },
      theDtChange(e) {
        if (e == '') {
          return this.form.userId = e
        }
        this.form.userId = e
        this.getEcharts()

      },
      selectTime(e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
        this.form.getType = '';
        this.getEcharts()
      },
      thetimechange(e) {
        this.form.getType = e;
        this.form.startDate = '';
        this.form.endDate = ''
        this.getEcharts()

      },
      getEcharts() {
        this.getStatisticsUser(this.form).result(res => {
          this.echartsStr1Value = [{
            name: "总拜访数",
            value: res.data.data.dtVisitorNum - res.data.data.visitorNum
          }, {
            name: "自己拜访数",
            value: res.data.data.visitorNum
          }];
          this.echartsStr2Value = [{
            name: "总签约数",
            value: res.data.data.dtKpi - res.data.data.userKpi
          }, {
            name: "自己签约数",
            value: res.data.data.userKpi
          }];
          this.DrawEcharts()
        })


        this.getStatisticsUserInteract(this.form)
        this.getStatisticsUserOpportunity(this.form)
        this.getStatisticsUserVisitor(this.form)
      }
    },
    created() {
     
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }
      // this.getUserList({currentPage:1,pageSize:10});
      this.getProjectUserAll({
          postId: 5,
          projectId: this.form.projectId,
        })
    }
  }
</script>

<style scoped>
  .Divbox {
    width: 32%;
    height: 47%;
    margin: 10px 0;
    border: 1px solid black;
    overflow: hidden;
  }

  .Divbox_box::-webkit-scrollbar {
    width: 0 !important
  }
</style>



// WEBPACK FOOTER //
// src/views/data/personalAnalysis.vue